import React from "react";
import "../../Assets/Scss/HeadBanner.scss";

function HeadBanner({ domainData, name }) {
  return (
    <div
      className="head-container"
      style={{ backgroundColor: domainData?.header_color }}
    >
      <div
        className="w-100 d-flex align-items-center justify-content-center"
        style={{ height: "250px" }}
      >
        <h2 style={{ color: "#FFFFFF" }}>{name}</h2>
      </div>
      <div className="d-flex w-100 justify-content-center">
        <div className="arrow"></div>
      </div>
    </div>
  );
}

export default HeadBanner;
